import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { useSettings } from '@/context/SettingsContext';
import { Dumbbell, Sparkles, Heart } from 'lucide-react';

const SpaPage = () => {
  const { t } = useLanguage();
  const { settings } = useSettings();

  const services = [
    {
      icon: Dumbbell,
      title: t('spa.fitness.title'),
      description: t('spa.fitness.description'),
      image: 'https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg?auto=compress&cs=tinysrgb&w=800',
      free: true
    },
    {
      icon: Heart,
      title: t('spa.wellness.title'),
      description: t('spa.wellness.description'),
      image: 'https://images.pexels.com/photos/3757954/pexels-photo-3757954.jpeg?auto=compress&cs=tinysrgb&w=800',
      free: true
    },
    {
      icon: Sparkles,
      title: t('spa.treatments.title'),
      description: t('spa.treatments.description'),
      image: 'https://images.pexels.com/photos/3757941/pexels-photo-3757941.jpeg?auto=compress&cs=tinysrgb&w=800',
      free: false
    },
  ];

  return (
    <div data-testid="spa-page">
      {/* Hero */}
      <section
        className="relative h-[60vh] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `url('/images/general/general_1.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-holiday-purple/60" />
        <div className="relative z-10 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-heading font-bold mb-4">{t('spa.title')}</h1>
          <p className="text-xl text-white/80">{t('spa.subtitle')}</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section-padding bg-white" data-testid="spa-services">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
                data-testid={`spa-service-${index}`}
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className={`absolute top-4 right-4 px-3 py-1 rounded-full text-sm font-medium ${
                    service.free ? 'bg-holiday-green text-white' : 'bg-holiday-purple text-white'
                  }`}>
                    {service.free ? 'Ücretsiz' : 'Ücretli'}
                  </div>
                </div>
                <div className="p-8">
                  <div className="w-12 h-12 bg-holiday-purple/10 rounded-full flex items-center justify-center mb-4">
                    <service.icon className="w-6 h-6 text-holiday-purple" />
                  </div>
                  <h3 className="text-2xl font-heading font-bold text-gray-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-gray-600">{service.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-16">
            <p className="text-xl text-gray-600 italic font-heading">
              "{t('spa.goal')}"
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gray-50">
        <div className="container-custom text-center">
          <h2 className="text-4xl font-heading font-bold text-gray-900 mb-4">
            {t('hero.cta')}
          </h2>
          <p className="text-gray-600 mb-8">{t('hero.concept')}</p>
          <a
            href={settings.reservation_url || "https://www.ihg.com"}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary inline-block rounded-sm"
            data-testid="spa-cta"
          >
            {t('nav.bookNow')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default SpaPage;
